import React from 'react'

function ID4() {
    return (
        <div>
            <h3>
                <strong>
                    "1С:Управление торговлей для Казахстана 8" &mdash; это современный инструмент для повышения эффективности бизнеса торгового предприятия.
                </strong>
            </h3>
            <p>
                "1С:Управление торговлей для Казахстана 8" позволяет в комплексе автоматизировать задачи оперативного и управленческого учета, анализа и
                планирования торговых операций, обеспечивая тем самым эффективное управление современным торговым предприятием.
            </p>
            <p>Предметная область, автоматизируемая с помощью "1С:Управление торговлей для Казахстана 8", может быть представлена в виде следующей схемы.</p>
            <p></p>
            <p>
                Программный продукт "1С:Предприятие 8. Управление торговлей для Казахстана" включает технологическую платформу "1С:Предприятие 8" и конфигурацию
                (прикладное решение) "Управление торговлей для Казахстана" редакция 3.
            </p>
            <p>
                Конфигурация "Управление торговлей для Казахстана" разработана в соответствии с правилами ведения торгового учета в Республике Казахстан.
                Правила ведения учета настроены именно в конфигурации. " Управление торговлей для Казахстана" выпускается в следующих версиях:
            </p>
            <ul>
                <li>
                    <a href="https://1c.kz/v8/RegionalSolutions_KZ_UT.php#prof">ПРОФ</a>
                </li>
                <li>
                    <a href="https://1c.kz/v8/RegionalSolutions_KZ_UT.php#base">Базовая</a>
                </li>
            </ul>
            <p>
                Впрограммемогут регистрироватьсякак уже совершенные, так и еще только планируемые хозяйственные операции. "1С:Управление торговлей для
                Казахстана 8" автоматизирует оформление практически всех первичных документов торгового и складского учета, а также документов движения денежных
                средств.
            </p>
            <p>
                "1С:Управление торговлей для Казахстана 8" рассчитана на любые виды торговых операций. Реализованы функции учета&ndash;от ведения справочников и
                ввода первичных документов до получения различных аналитических отчетов.
            </p>
            <p>
                Решение позволяет вести управленческий учет по торговому предприятию в целом. Для предприятия холдинговой структуры документы могут оформляться
                от имени нескольких организаций, входящих в холдинг.
            </p>
            <p>
                Функционал решения может быть гибко адаптирован путем включения/отключения различных функциональных опций. Например, таким образом программу
                можно значительно упростить для небольшой организации, отключив множество возможностей необходимых только крупным компаниям (отключенный
                функционал скрывается из интерфейса и не мешает работе пользователей). Далее будет приведено описание функционала решения с включением всех
                опций.
            </p>
            <p>
                "1С:Управление торговлей для Казахстана 8" обеспечивает автоматический подбор данных, необходимых для ведения бухгалтерского учета, ипередачу
                этих данных в
                <a href="http://v8.1c.ru/buhv8/">
                    <strong>"1С:Бухгалтерию для Казахстана8"</strong>
                </a>
                .
            </p>
            <p>
                Использование программы "Управление торговлей для Казахстана" совместно с другими программами позволяет комплексно автоматизировать
                оптово-розничные предприятия. Программа "Управление торговлей для Казахстана" может использоваться в качестве управляющей системы для решения
                <a href="http://v8.1c.ru/retail/">
                    <strong>"1С:Розница для Казахстана8"</strong>
                </a>
                .
            </p>
            <h3>Общая характеристика</h3>
            <h4>Управление отношениями с клиентами (CRM)</h4>
            <h4>
                Управление отношениями с клиентами, известное также как CRM или Customer Relationship Management, является неотъемлемой функциональной областью
                современной комплексной информационной системы предприятия.
            </h4>
            <h4>
                CRM &mdash; это концепция управления отношениями с клиентами в условиях активной конкуренции, нацеленная на максимальное освоение потенциала
                каждого клиента и партнера в интересах предприятия.
            </h4>
            <h4>Концепция CRM предполагает регулярный сбор и анализ информации о каждом клиенте:</h4>
            <ul>
                <li>как клиент отреагировал на деловое предложение,</li>
                <li>доволен ли он качеством обслуживания,</li>
                <li>меняются ли его предпочтения со временем,</li>
                <li>насколько аккуратно он выполняет взятые на себя обязательства,</li>
                <li>сколько дохода клиент приносит (или мог бы принести) предприятию.</li>
            </ul>
            <h4>Для управления отношениями с клиентами прикладное решение предлагает следующие возможности:</h4>
            <ul>
                <li>регламентировать предварительные процессы продаж, происходящие до момента оформления конкретных документов продажи,</li>
                <li>регистрировать контакты с новыми партнерами,</li>
                <li>планировать события и получать напоминания по ним,</li>
                <li>хранить полную контактную информацию по контрагентам и их сотрудникам, историю взаимодействия с ними,</li>
                <li>управлять процессом продаж с использованием механизма бизнес-процессов (сделки с клиентом),</li>
                <li>анализировать незавершенные и планировать предстоящие сделки с покупателями и потенциальными клиентами,</li>
                <li>регистрировать и оперативно отрабатывать претензии клиентов,</li>
                <li>анализировать и оценивать эффективность работы менеджеров с клиентами.</li>
            </ul>
            <h4>Управление продажами</h4>
            <h4>Для управления продажами прикладное решение предоставляет следующие возможности:</h4>
            <h4>&middot; задать правила продажи индивидуальные для клиента или типовые для сегментов клиентов;</h4>
            <h4>&middot; выставить коммерческие предложения клиентам;</h4>
            <h4>&middot; отразить потребности клиентов в покупке товаров, в услуге;</h4>
            <h4>&middot; отразить операцию отгрузки товаров клиенту;</h4>
            <h4>&middot; организовать доставку товаров;</h4>
            <h4>&middot; оформить корректировку реализации;</h4>
            <h4>&middot; оформить возврат товаров от клиента.</h4>
            <h4>Процесс оформления продаж можно представить в виде следующей схемы:</h4>
            <h4>Управление закупками</h4>
            <h4>Для управления закупками предусмотрены различные возможности:</h4>
            <ul>
                <li>подбор поставщиков товаров;</li>
                <li>различные условия закупок;</li>
                <li>поддержка различных схем приема товаров от поставщика;</li>
                <li>различные варианты формирования заказов поставщикам и контроль их исполнения;</li>
                <li>корректировка и закрытие заказов поставщикам;</li>
                <li>мониторинг цен поставщиков;</li>
                <li>оформление поставки товаров;</li>
                <li>составление графиков поставок и графиков платежей;</li>
                <li>корректировка поступлений и возвраты поставщикам.</li>
            </ul>
            <h4>Процесс оформления закупок можно представить в виде следующей схемы:</h4>
            <h4>
                В данной схеме представлены все этапы оформления закупок &ndash; начиная с момента регистрации условий закупок (цен поставщика, условий оплаты и
                т.д.) до момента возврата поставщику некачественного товара.
            </h4>
            <h4>Денежные средства</h4>
            <p>
                В конфигурации реализована функциональность заявок на расходование денежных средств, поддерживаются этапы формирования и утверждения заявок,
                контролируется выполнение платежей по заявкам. На основании заявок, а также графиков оплаты по заказам клиентов и заказам поставщикам система
                формирует платежный календарь, с помощью которого можно детально спланировать движение и остатки денежных средств, распределить исходящие
                платежи, выявить кассовые разрывы и принять меры к их устранению.
            </p>
            <p>
                В учете безналичных денежных средств разделена регистрация оперативной информации о входящих и исходящих платежах (по первичным платежным
                документам) и регистрация выписок (реализованных отдельным документом). Это позволяет повысить оперативность учета (в частности,
                взаиморасчетов), не искажая при этом учет средств на расчетных счетах, облегчить обработку платежек и выписок, получить полный контроль над
                денежными средствами, находящимися в процессе зачисления, списания или перемещения.
            </p>
            <p>
                Существенно развит функционал учета расчетов с банком по эквайринговым операциям. Помимо регистрации операций платежа и возврата по платежным
                картам, добавлен этап регистрации отчетов от банков по зачислению платежей, списанию возвратов, удержанию комиссии, что позволяет отследить
                каждую операцию от момента проведения платежа до поступления средств на расчетный счет.
            </p>
            <h4>Управление складом</h4>
            <h4>Для процесса управления складом предусмотрены следующие возможности:</h4>
            <ul>
                <li>использование рабочих участков для разделения складских зон;</li>
                <li>разделение областей хранения в соответствии со складскими группами (молоко, рыба, мороженое, мебель и т. д.);</li>
                <li>ведение учета товаров на уровне складских ячеек (адресное хранение товаров);</li>
                <li>ведение учета товаров на уровне склада со справочным использованием складских ячеек (справочное размещение товаров);</li>
                <li>использование различных стратегий отбора для оптимизации размещения товаров в ячейках;</li>
                <li>оптимизация размещения товаров на адресном складе хранения в соответствии с размерами ячеек и упаковок;</li>
                <li>подпитка зон быстрого отбора для складов с адресным хранением товаров.</li>
            </ul>
            <h3>Организация хранения товаров на складе</h3>
            <h4>Хранение товаров на складе можно организовать следующими способами:</h4>
            <ul>
                <li>
                    <strong>без использования ячеек</strong>&ndash; самый простой вид хранения, позволяет вести учет товаров на уровне склада (помещения),
                </li>
                <li>
                    <strong>в складских ячейках справочного размещения</strong>&ndash;позволяет вести учет товаров в разрезе склада (помещения), предусмотрено
                    хранение товаров в ячейках, которым соответствует определенный адрес (секция, линия, стеллаж),
                </li>
                <li>
                    <strong>в складских ячейках адресного хранения</strong>&ndash; позволяет точно установить место нахождения товаров на складе, вести учет
                    товаров в разрезе ячеек.
                </li>
            </ul>
            <h4>
                Для предприятия может быть задано неограниченное количество складов. Для каждого склада можно определить свой вариант использования складских
                ячеек. Если склад имеет в своем составе несколько помещений, то вариант использования ячеек задается для каждого складского помещения.
            </h4>
            <h4>Управление запасами</h4>
            <h4>Ключевыми целями процесса управления запасами являются:</h4>
            <ul>
                <li>наличие запасов на складе в необходимом количестве,</li>
                <li>достижение желаемого уровня обслуживания клиентов;</li>
                <li>снижение потребности в оборотных средствах;</li>
                <li>улучшение показателей оборачиваемости товаров;</li>
                <li>снижение затрат предприятия на закупку и хранение товаров,</li>
                <li>устранение избыточных запасов.</li>
            </ul>
            <h4>
                Для полного достижения вышеуказанных целей прикладное решение позволяет поддерживать запасы на складе, обеспечивать количество товаров по
                текущим заказам на отгрузку и обеспечивать потребности по планам закупок.
            </h4>
            <h4>Релизовано упрощенное поддержание запасов на складе сопряженое с выполнением следующих задач:</h4>
            <ul>
                <li>контроль текущего остатка товаров на складе,</li>
                <li>определение максимального и минимального запасов,</li>
                <li>расчет среднедневного потребления товаров,</li>
                <li>определение поставщика и условия работы с ним,</li>
                <li>формирование заказов поставщикам, на то количество товаров, которое необходимо для поддержания запаса.</li>
            </ul>
            <h4>Расширенное поддержание запасов на складе сопряжено с выполнением задач:</h4>
            <h4>&middot; контроль текущего остатка товаров на складе;</h4>
            <h4>&middot; определение максимального и минимального запасов;</h4>
            <h4>&middot; определение способа и метода обеспечения потребностей;</h4>
            <h4>&middot; выбор источника обеспечения потребностей;</h4>
            <h4>&middot; расчет среднедневного потребления товаров;</h4>
            <h4>&middot; определение поставщика и условия работы с ним;</h4>
            <h4>&middot; формирование сроков и графиков поставки товаров (дата поставки, дата отгрузки);</h4>
            <h4>&middot; формирование различных заказов (заказы поставщика, заказы на сборку, заказы на перемещение).</h4>
            <p>Для обеспечения текущих заказов на отгрузку предусмотрены следующие возможности:</p>
            <ul>
                <li>определение способа обеспечения потребностей,</li>
                <li>корректировка графиков поставки,</li>
                <li>контроль количества товаров, требуемого для обеспечения потребностей,</li>
                <li>определение источника обеспечения потребностей,</li>
                <li>контроль количества товаров, которое уже обеспечено по заказу на отгрузку,</li>
                <li>выбор режима обеспечения заказов на отгрузку,</li>
                <li>формирование различных заказов.</li>
            </ul>
            <p>
                Для обеспечения потребностей по планам закупок предусмотрено рабочее место<strong>Формирование заказов поставщикам по планам</strong>,
                использование которого позволяет:
            </p>
            <ul>
                <li>проанализировать потребности по планам закупок и уточнить количество товаров, необходимое к заказу у поставщика;</li>
                <li>определить состав и объем заказа поставщику;</li>
                <li>определить поставщика, условия работы с ним (соглашение с поставщиком) и склад, который требуется обеспечить;</li>
                <li>сформировать заказы поставщикам, на то количество товаров, которое необходимо для обеспечения планов по закупкам.</li>
            </ul>
            <h3></h3>
            <h3>Мониторинг и анализ показателей деятельности предприятия</h3>
            <p>Для контроля и анализа целевых показателей деятельности предприятия можно использовать данные монитора целевых показателей.</p>
            <p>Система целевых показателей - приборная панель управления для менеджеров предприятия всех уровней.</p>
            <p>Использование системы целевых показателей позволяет:</p>
            <ul>
                <li>своевременно выявлять проблемные участки на любом этапе управления предприятием;</li>
                <li>контролировать выполнение поставленных целей;</li>
                <li>анализировать эффективность ключевых процессов предприятия с помощью показателей;</li>
                <li>анализировать структуры целей;</li>
                <li>оценивать текущее состояние бизнеса;</li>
                <li>
                    топ-менеджерам принимать оптимальные управленческие решения по ключевым процессам на основании данных по целевым показателям предприятия.
                </li>
            </ul>
            <p>Преимущества монитора целевых показателей:</p>
            <ul>
                <li>простота использования;</li>
                <li>гибкая система настроек;</li>
                <li>предопределенный набор настроек;</li>
                <li>возможность создания и контроля собственных показателей;</li>
                <li>получение информации, как в сжатом виде, так и в более развернутом виде.</li>
            </ul>
            <h4>Новые технические решения</h4>
            <h4>Изменен интерфейс формы ряда документов. Формы адаптированы под режимТакси.</h4>
            <p>
                Изменения внесены в интерфейс разделов группы<strong>Администрирование</strong>. Информация в каждом разделе сгруппирована по тематике настроек.
            </p>
            <h4>Оптимизация процедуры обработки данных</h4>
            <p>Оптимизированы процедуры обработки данных, выполняемых при обновлении информационной базы.</p>
            <p></p>
            <h3>Управление торговлей для Казахстана базовая</h3>
            <p>Управление торговлей для Казахстана базовая" редакция 3 представляет собой однопользовательский аналог версииПРОФ продукта (редакции 3).</p>
            <p>
                "1С:Предприятие 8. Управление торговлей для Казахстана. Базовая версия" - это однопользовательская программа для автоматизации задач
                оперативного и управленческого учета, анализа и планирования торговых операций. По сравнению с версией ПРОФ она имеет следующие отличия:
            </p>
            <ul>
                <li>
                    не поддерживается ведение учета по нескольким фирмам в одной информационной базе; при этом имеется возможность ведения учета нескольких
                    организаций в отдельных информационных базах на одном компьютере;
                </li>
                <li>
                    не поддерживается возможность указания принадлежности структурных единиц определенным налогоплательщикам по разным видам налогов для
                    организаций, имеющих филиалы и представительства;
                </li>
                <li>одновременно с одной информационной базой может работать только один пользователь;</li>
                <li>не поддерживается изменение конфигурации, можно применять только типовую конфигурацию и устанавливать ее обновления;</li>
                <li>не поддерживается работа в варианте клиент-сервер;</li>
                <li>не поддерживается работа распределенных информационных баз;</li>
                <li>не поддерживается COM-соединение и Automation-сервер.</li>
            </ul>
            <p>
                Если в организации возникнет потребность ведения многофирменного учета в единой информационной базе, одновременной работы нескольких
                пользователей или появятся другие задачи, которые не решаются в рамках базовой версии, то в этом случае организация сможет перейти на программу
                "1С:Предприятие 8. Управление торговлей для Казахстана" версии ПРОФ, не имеющую указанных отличий.
            </p>
        </div>
    )
}

export { ID4 }
